// modules
import React from 'react'

const PredefinedEmpty = ({ className = '' }) => (
  <div
    className={`ant-empty predefined-empty${className ? ` ${className}` : ''}`}>
    <p className="ant-empty-description">No Data</p>
  </div>
)

export default PredefinedEmpty
